$(function() {

});


// function addToAudience(role) {

//     window.dataLayer = window.dataLayer || [];
//     window.dataLayer.push({
//         'event': 'add_to_audience',
//         'role': role
//  });

// }
